
import {Component, Mixins, Watch, Prop} from 'vue-property-decorator';
import ListelemeTuruPicker from "@/components/pickers/ListelemeTuruPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

export enum ListelemeTuru {
  ESAS_NO_ARALIGI = 2,
  KISI_ILE_ARAMA = 3,
  KURUM_ILE_ARAMA = 4,
  ACILIS_TARIH_ARALIGI = 5,
  KAPANIS_TARIH_ARALIGI = 6,
  SON_1_GUN = 7,
  SON_1_HAFTA = 8,
  SON_2_HAFTA = 9,
  SON_1_AY = 10,
  ICRAPRO_DOSYALARI = 11
}

@Component({
  computed: {
    ListelemeTuru() {
      return ListelemeTuru
    },
    ExcelKullanildiMi() {
      return this.excelKullanildi || this.excelKullanildi === "";
    }
  },
  components: {Dates, ListelemeTuruPicker}
})
export default class DosyaFiltrelemeCard extends Mixins(SimpleInputMixin) {
  @Prop() excelKullanildi!: string | boolean;

  // TODO: burası saçma galdi komple sıfırlanamaz mı
  @Watch('localValue.listeleme_turu')
  onListelemeTuruChange(newVal: number) {
    console.log("Listeleme türü değişti:", newVal);
    // Listeleme türü değiştiğinde sadece ilgili olmayan alanları temizle
    if (newVal !== ListelemeTuru.KISI_ILE_ARAMA) {
      this.localValue.tcKimlikNo = '';
      this.localValue.adi = '';
      this.localValue.soyadi = '';
    }
    if (newVal !== ListelemeTuru.KURUM_ILE_ARAMA) {
      this.localValue.kurumAdi = '';
      this.localValue.mersisNo = '';
      this.localValue.vergiNo = '';
    }
    if (newVal !== ListelemeTuru.ESAS_NO_ARALIGI) {
      this.localValue.dosyaYil = undefined;
      this.localValue.dosyaSira = undefined;
      this.localValue.dosyaSira2 = undefined;
    }
    if (![ListelemeTuru.ACILIS_TARIH_ARALIGI, ListelemeTuru.KAPANIS_TARIH_ARALIGI].includes(newVal)) {
      this.localValue.baslangicTarihi = '';
      this.localValue.bitisTarihi = '';
    }
    this.input();
  }
}
